import { Injectable, EventEmitter, Output } from '@angular/core';
import { ToastType, Toast } from './toast';
import { Observable, BehaviorSubject } from 'rxjs';
import { CommonUtils } from '../../utils/common-utils';
import { map } from 'rxjs/operators';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ToastsService {  

  private readonly _toasts: BehaviorSubject<Toast[]> = new BehaviorSubject<Toast[]>([]);
  readonly toasts$ = this._toasts.asObservable();  
  set toasts(val: Toast[]) {
    this._toasts.next(val);
  }
  get toasts() {
    return this._toasts.getValue();
  }

  addToast(title: string, content: string, type: ToastType) {
    let id = CommonUtils.generateUniqueId();
    this.toasts = [
      ...this.toasts,
      { id: id, title: title, content: content, type: type }
    ];
  }

  removeToast(id: string) {
    this.toasts = this.toasts.filter(t => t.id !== id);
  }

  constructor() { }   
}
